import { render, staticRenderFns } from "./CollectionHistory.vue?vue&type=template&id=559e186e&scoped=true"
import script from "./CollectionHistory.vue?vue&type=script&lang=js"
export * from "./CollectionHistory.vue?vue&type=script&lang=js"
import style0 from "./CollectionHistory.vue?vue&type=style&index=0&id=559e186e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e186e",
  null
  
)

export default component.exports